  
import { AddAction } from './AddAction';
import { AddSuccessAction } from './AddSuccessAction';
import { ClearErrorsAction } from './ClearErrorsAction';
import { ClearSelectionAction } from './ClearSelectionAction';
import { DeleteAction } from './DeleteAction';
import { DeleteSuccessAction } from './DeleteSuccessAction';
import { GetSelectionAction } from './GetSelectionAction';
import { GetSelectionSuccessAction } from './GetSelectionSuccessAction';
import { QueryListAction } from './QueryListAction';
import { QuerySuccessAction } from './QuerySuccessAction';
import { StopLoadingAction } from './StopLoadingAction';
import { TileErrorsAction } from './TileErrorsAction';

export type Actions<TModel> = AddAction<TModel> | AddSuccessAction<TModel> | ClearErrorsAction<TModel> | ClearSelectionAction<TModel> | DeleteAction<TModel> | DeleteSuccessAction<TModel> | GetSelectionAction<TModel> | GetSelectionSuccessAction<TModel> | QueryListAction<TModel> | QuerySuccessAction<TModel> | StopLoadingAction<TModel> | TileErrorsAction<TModel>;

export * from './AddAction';
export * from './AddSuccessAction';
export * from './ClearErrorsAction';
export * from './ClearSelectionAction';
export * from './DeleteAction';
export * from './DeleteSuccessAction';
export * from './GetSelectionAction';
export * from './GetSelectionSuccessAction';
export * from './QueryListAction';
export * from './QuerySuccessAction';
export * from './StopLoadingAction';
export * from './TileErrorsAction';




// WEBPACK FOOTER //
// ./src/app/pillar/dashboard/store/actions/index.ts